<template>
  <transition name="fade">
    <div :class="{ 'loader-fullscreen': fullscreen }" v-show="visibility">
      <div class="spiner-example">
        <div class="sk-spinner sk-spinner-three-bounce">
          <div class="sk-bounce1"></div>
          <div class="sk-bounce2"></div>
          <div class="sk-bounce3"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    visibility: {
      default: false
    },
    fullscreen: {
      default: false
    }
  },
  watch: {
    fullscreen (res) {
      this.overflowToggle(res)
    }
  },
  methods: {
    overflowToggle (overflow) {
      const body = document.body
      overflow ? body.classList.add('overflow') : body.classList.remove('overflow')
    }
  },
  mounted () {
    this.overflowToggle(this.fullscreen)
  },
  destroyed () {
    document.body.classList.remove('overflow')
  }
}
</script>

<style lang="scss" scoped>
.loader-fullscreen {
  background-color: rgba(#fff, .4);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3000;

  .spiner-example {
    left: 50%;
    top: 50%;
    position: fixed;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loader/Loader.vue